import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/down.png'
import _imports_1 from '../../assets/performance/footer.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-244e86de")

_pushScopeId("data-v-244e86de")
const _hoisted_1 = {
  class: "Ecard",
  id: "trendChart"
}
const _hoisted_2 = { class: "testMain" }
const _hoisted_3 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 安装包下载 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("发送报告")
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("span", null, "删除", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 配置基线 ")
const _hoisted_10 = { class: "config_class" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_12 = {
  key: 0,
  class: "editRecipient"
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 可按如下任一形式批量添加： ")
const _hoisted_14 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode("1、zhangsan;lisi;wangwu ")
const _hoisted_16 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode("2、zhangsan(张三);lisi(李四);wangwu(王五) ")
const _hoisted_18 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode("3、zhangsan(张三) <zhangsan@tencent.com>;lisi(李四) <lisi@tencent.com>; wangwu(王五) <wangwu@tencent.com> ")
const _hoisted_20 = /*#__PURE__*/_createVNode("span", null, "发送报告", -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_22 = { class: "spacName" }
const _hoisted_23 = {
  id: "thread_scroll",
  class: "TitleStyle"
}
const _hoisted_24 = /*#__PURE__*/_createVNode("span", null, null, -1)
const _hoisted_25 = /*#__PURE__*/_createTextVNode("内存风险 ")
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" 风险判断标准： ")
const _hoisted_27 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createTextVNode("低风险：unreleaseMallocSize 升高 小于10MB ")
const _hoisted_29 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_30 = /*#__PURE__*/_createTextVNode("中风险：unreleaseMallocSize 升高 10MB~30MB ")
const _hoisted_31 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_32 = /*#__PURE__*/_createTextVNode("高风险：unreleaseMallocSize 升高 大于30MB ")
const _hoisted_33 = /*#__PURE__*/_createVNode("i", {
  class: "el-icon-question",
  size: "small"
}, null, -1)
const _hoisted_34 = /*#__PURE__*/_createVNode("h6", { style: {"display":"flex","align-items":"center","margin":"8px 0 8px 0"} }, [
  /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆"),
  /*#__PURE__*/_createTextVNode(" Native内存测试(MB) ")
], -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("div", null, "MallocSize", -1)
const _hoisted_36 = /*#__PURE__*/_createVNode("div", null, "MallocSize", -1)
const _hoisted_37 = { key: 0 }
const _hoisted_38 = /*#__PURE__*/_createVNode("h6", { style: {"display":"flex","align-items":"center","margin":"8px 0 8px 0"} }, [
  /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆"),
  /*#__PURE__*/_createTextVNode(" 内存风险Top增长函数 ")
], -1)
const _hoisted_39 = /*#__PURE__*/_createVNode("span", { style: {"margin":"5px"} }, "vs", -1)
const _hoisted_40 = /*#__PURE__*/_createVNode("div", null, "UnreleasedNativeMallocSize", -1)
const _hoisted_41 = /*#__PURE__*/_createVNode("div", null, "内存增长值(MB)", -1)
const _hoisted_42 = /*#__PURE__*/_createVNode("div", null, "UnreleasedNativeMallocSize", -1)
const _hoisted_43 = /*#__PURE__*/_createVNode("div", null, "内存增长值(MB)", -1)
const _hoisted_44 = { key: 1 }
const _hoisted_45 = /*#__PURE__*/_createVNode("h6", { style: {"display":"flex","align-items":"center","margin":"8px 0 8px 0"} }, [
  /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆"),
  /*#__PURE__*/_createTextVNode(" 内存风险Top增长so ")
], -1)
const _hoisted_46 = /*#__PURE__*/_createVNode("span", { style: {"margin":"5px"} }, "vs", -1)
const _hoisted_47 = /*#__PURE__*/_createVNode("div", null, "UnreleasedNativeMallocSize", -1)
const _hoisted_48 = /*#__PURE__*/_createVNode("div", null, "内存增长值(MB)", -1)
const _hoisted_49 = /*#__PURE__*/_createVNode("div", null, "UnreleasedNativeMallocSize", -1)
const _hoisted_50 = /*#__PURE__*/_createVNode("div", null, "内存增长值(MB)", -1)
const _hoisted_51 = { class: "spacName" }
const _hoisted_52 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("内存趋势")
], -1)
const _hoisted_53 = /*#__PURE__*/_createVNode("h6", { style: {"display":"flex","align-items":"center","margin":"8px 0 8px 0"} }, [
  /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆"),
  /*#__PURE__*/_createTextVNode(" 场景趋势 ")
], -1)
const _hoisted_54 = /*#__PURE__*/_createVNode("div", {
  id: "native_trend",
  style: {"height":"350px","width":"100%"}
}, null, -1)
const _hoisted_55 = {
  key: 0,
  style: {"display":"flex","align-items":"center","margin":"8px 0 8px 0"}
}
const _hoisted_56 = /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆", -1)
const _hoisted_57 = /*#__PURE__*/_createTextVNode(" so趋势 ")
const _hoisted_58 = { key: 1 }
const _hoisted_59 = /*#__PURE__*/_createVNode("div", {
  id: "so_func_trend",
  style: {"height":"350px","width":"100%"}
}, null, -1)
const _hoisted_60 = /*#__PURE__*/_createVNode("h6", { style: {"display":"flex","align-items":"center","margin":"8px 0 8px 0"} }, [
  /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆"),
  /*#__PURE__*/_createTextVNode(" 函数趋势 ")
], -1)
const _hoisted_61 = /*#__PURE__*/_createVNode("div", {
  id: "native_func_trend",
  style: {"height":"350px","width":"100%"}
}, null, -1)
const _hoisted_62 = {
  key: 1,
  class: "spacName"
}
const _hoisted_63 = /*#__PURE__*/_createVNode("h5", {
  id: "thread_scroll",
  class: "TitleStyle"
}, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("重要Native内存模块信息 ")
], -1)
const _hoisted_64 = /*#__PURE__*/_createVNode("p", null, "注：次数为函数调用次数", -1)
const _hoisted_65 = { key: 0 }
const _hoisted_66 = /*#__PURE__*/_createVNode("h6", { style: {"display":"flex","align-items":"center","margin":"8px 0 8px 0"} }, [
  /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆"),
  /*#__PURE__*/_createTextVNode(" 模块趋势图 ")
], -1)
const _hoisted_67 = /*#__PURE__*/_createVNode("div", {
  id: "module_trend",
  style: {"height":"350px","width":"100%"}
}, null, -1)
const _hoisted_68 = /*#__PURE__*/_createVNode("h6", { style: {"display":"flex","align-items":"center","margin":"8px 0 8px 0"} }, [
  /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆"),
  /*#__PURE__*/_createTextVNode(" 模块历史版本数据 ")
], -1)
const _hoisted_69 = /*#__PURE__*/_createVNode("h6", { style: {"display":"flex","align-items":"center","margin":"8px 0 8px 0"} }, [
  /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆"),
  /*#__PURE__*/_createTextVNode(" 模块详细数据 ")
], -1)
const _hoisted_70 = {
  key: 2,
  class: "spacName"
}
const _hoisted_71 = /*#__PURE__*/_createVNode("h5", {
  id: "thread_scroll",
  class: "TitleStyle"
}, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("全量Native数据查看 ")
], -1)
const _hoisted_72 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_73 = /*#__PURE__*/_createTextVNode(" 导出数据")
const _hoisted_74 = { class: "native_table" }
const _hoisted_75 = {
  key: 3,
  class: "spacName"
}
const _hoisted_76 = /*#__PURE__*/_createVNode("h5", {
  id: "thread_scroll",
  class: "TitleStyle"
}, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("so数据查看 ")
], -1)
const _hoisted_77 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_78 = { class: "native_table" }
const _hoisted_79 = /*#__PURE__*/_createVNode("h5", {
  id: "thread_scroll",
  class: "TitleStyle"
}, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("内存火焰图 ")
], -1)
const _hoisted_80 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_81 = /*#__PURE__*/_createTextVNode("全屏显示")
const _hoisted_82 = {
  key: 4,
  style: {"mini-height":"400px"}
}
const _hoisted_83 = /*#__PURE__*/_createVNode("div", {
  id: "chart",
  class: "chart-area"
}, null, -1)
const _hoisted_84 = { key: 5 }
const _hoisted_85 = { key: 6 }
const _hoisted_86 = /*#__PURE__*/_createVNode("h5", {
  id: "thread_scroll",
  class: "TitleStyle"
}, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("内存堆栈对比 ")
], -1)
const _hoisted_87 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_88 = /*#__PURE__*/_createTextVNode("全屏显示")
const _hoisted_89 = { style: {"display":"flex"} }
const _hoisted_90 = { class: "frames-info" }
const _hoisted_91 = /*#__PURE__*/_createTextVNode(" 增加堆栈数:")
const _hoisted_92 = { class: "frames-num" }
const _hoisted_93 = /*#__PURE__*/_createTextVNode("个, ")
const _hoisted_94 = { class: "frames-info" }
const _hoisted_95 = /*#__PURE__*/_createTextVNode(" 相同堆栈数:")
const _hoisted_96 = { class: "frames-num" }
const _hoisted_97 = /*#__PURE__*/_createTextVNode("个, ")
const _hoisted_98 = { class: "frames-info" }
const _hoisted_99 = /*#__PURE__*/_createTextVNode(" 减少堆栈数:")
const _hoisted_100 = { class: "frames-num" }
const _hoisted_101 = /*#__PURE__*/_createTextVNode("个 ")
const _hoisted_102 = {
  key: 0,
  id: "merge",
  class: "chart-area"
}
const _hoisted_103 = { key: 1 }
const _hoisted_104 = {
  key: 7,
  class: "spacName"
}
const _hoisted_105 = /*#__PURE__*/_createVNode("h5", {
  id: "thread_scroll",
  class: "TitleStyle"
}, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("全量Native数据查看 ")
], -1)
const _hoisted_106 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_107 = /*#__PURE__*/_createTextVNode(" 导出数据")
const _hoisted_108 = { class: "native_table" }
const _hoisted_109 = { class: "spacName" }
const _hoisted_110 = /*#__PURE__*/_createVNode("h5", {
  id: "thread_scroll",
  class: "TitleStyle"
}, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("源数据下载 ")
], -1)
const _hoisted_111 = { key: 8 }
const _hoisted_112 = /*#__PURE__*/_createVNode("div", { style: {"display":"flex","align-items":"center"} }, [
  /*#__PURE__*/_createVNode("h5", {
    id: "thread_scroll",
    class: "TitleStyle"
  }, [
    /*#__PURE__*/_createVNode("span"),
    /*#__PURE__*/_createTextVNode(" 测试说明 ")
  ])
], -1)
const _hoisted_113 = /*#__PURE__*/_createVNode("div", { class: "footer" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1)
const _hoisted_114 = {
  key: 0,
  class: "backdrop"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_empty = _resolveComponent("el-empty")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode("div", _hoisted_2, [
                  _createVNode(_component_el_form, {
                    inline: true,
                    size: "mini"
                  }, {
                    default: _withId(() => [
                      (_ctx.localProject == 7)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            label: "增量全量"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.type,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.type = $event)),
                                onChange: _cache[2] || (_cache[2] = ($event: any) => (
                    _ctx.memoryChange([
                      'is_all',
                      'report_type',
                      'task_id',
                      'device_id',
                      'level',
                      'scene_id',
                    ])
                  ))
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.typeList, (item, k) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: k,
                                      label: item.name,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode("div", _hoisted_3, [
                    _createVNode(_component_el_form, {
                      inline: true,
                      size: "mini"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_form_item, { label: "测试类型" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              filterable: "",
                              onChange: _cache[3] || (_cache[3] = ($event: any) => (
                      _ctx.memoryChange([
                        'report_type',
                        'task_id',
                        'device_id',
                        'level',
                        'scene_id',
                      ])
                    )),
                              modelValue: _ctx.type_query,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.type_query = $event)),
                              placeholder: "请选择"
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.perfTypeOptions, (item, k) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: k,
                                    label: item.name,
                                    value: item.report_type
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "选择日期" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              key: _ctx.componentKey,
                              modelValue: _ctx.date_name,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.date_name = $event)),
                              onChange: _cache[6] || (_cache[6] = ($event: any) => (
                      _ctx.memoryChange([
                        'task_id',
                        'device_id',
                        'level',
                        'scene_id',
                      ])
                    )),
                              placeholder: "请选择"
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.perfDateOptions, (item, k) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: k,
                                    label: item.name,
                                    value: item.name
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "选择设备" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.device_id,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.device_id = $event)),
                              onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.memoryChange(['device_id', 'level', 'scene_id']))),
                              placeholder: "请选择"
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.perfDeviceOptions, (item, k) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: k,
                                    label: item.name,
                                    value: item.device_id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, null, {
                          default: _withId(() => [
                            _createVNode(_component_el_button, {
                              onClick: _ctx.downloadFile,
                              type: "primary"
                            }, {
                              default: _withId(() => [
                                _hoisted_4
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, null, {
                          default: _withId(() => [
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: _ctx.memoryBtn
                            }, {
                              default: _withId(() => [
                                _hoisted_5
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, null, {
                          default: _withId(() => [
                            _createVNode(_component_el_button, {
                              size: "mini",
                              type: "primary",
                              onClick: _ctx.sendOut,
                              class: "down_img"
                            }, {
                              default: _withId(() => [
                                _hoisted_6,
                                _hoisted_7
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, null, {
                          default: _withId(() => [
                            _createVNode(_component_el_popconfirm, {
                              title: "将删除该任务下的选择的机型数据",
                              onConfirm: _cache[9] || (_cache[9] = ($event: any) => (_ctx.deleteBtn())),
                              placement: "top"
                            }, {
                              reference: _withId(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  size: "mini"
                                }, {
                                  default: _withId(() => [
                                    _hoisted_8
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.configShow = true)),
                      style: {"height":"25px"},
                      type: "primary",
                      size: "mini"
                    }, {
                      default: _withId(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode("div", _hoisted_10, [
                    _createVNode(_component_el_dialog, {
                      width: "30%",
                      modelValue: _ctx.configShow,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.configShow = $event))
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_form, {
                          inline: true,
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "基线测试" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  key: _ctx.componentKey,
                                  modelValue: _ctx.base_id,
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.base_id = $event)),
                                  placeholder: "请选择"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.perfDateOptionsOld, (item, k) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: k,
                                        label: item.name,
                                        value: item.name
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, null, {
                              default: _withId(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  onClick: _ctx.settingsBtn
                                }, {
                                  default: _withId(() => [
                                    _hoisted_11
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  (_ctx.edit)
                    ? (_openBlock(), _createBlock("div", _hoisted_12, [
                        _createVNode(_component_el_form, {
                          "label-position": "left",
                          "label-width": "100px",
                          model: _ctx.formMail,
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "邮件标题" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formMail.title,
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.formMail.title = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件发件人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                                  content: _withId(() => [
                                    _createTextVNode(" 指定的邮件发件人需要位于公司TOF发件人名单,否则无法发送邮件。默认邮件发件人" + _toDisplayString(_ctx.formMail.Sender), 1)
                                  ]),
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.formMail.Sender,
                                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.formMail.Sender = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件收件人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                                  content: _withId(() => [
                                    _hoisted_13,
                                    _hoisted_14,
                                    _hoisted_15,
                                    _hoisted_16,
                                    _hoisted_17,
                                    _hoisted_18,
                                    _hoisted_19
                                  ]),
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.formMail.addressee,
                                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.formMail.addressee = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件抄送人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formMail.CC_List,
                                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.formMail.CC_List = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_popconfirm, {
                              title: "确认发送报告吗？",
                              onConfirm: _cache[17] || (_cache[17] = ($event: any) => (_ctx.save_report(false))),
                              placement: "top"
                            }, {
                              reference: _withId(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  disabled: _ctx.get_is_super,
                                  size: "mini"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "暂无管理员权限",
                                      placement: "top",
                                      disabled: !_ctx.get_is_super
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_20
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"])
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              size: "mini",
                              type: "info",
                              onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.edit = false))
                            }, {
                              default: _withId(() => [
                                _hoisted_21
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["model"])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_22, [
                    _createVNode("h5", _hoisted_23, [
                      _hoisted_24,
                      _hoisted_25,
                      _createVNode(_component_el_tooltip, {
                        class: "item",
                        effect: "dark",
                        placement: "top-start"
                      }, {
                        content: _withId(() => [
                          _hoisted_26,
                          _hoisted_27,
                          _hoisted_28,
                          _hoisted_29,
                          _hoisted_30,
                          _hoisted_31,
                          _hoisted_32
                        ]),
                        default: _withId(() => [
                          _hoisted_33
                        ]),
                        _: 1
                      })
                    ]),
                    _hoisted_34,
                    _withDirectives(_createVNode(_component_el_table, {
                      border: "",
                      size: "mini",
                      "span-method": _ctx.mergeCells2,
                      "header-cell-style": {
                  background: '#5D99D5',
                  color: '#fff',
                },
                      data: _ctx.nativeData
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_table_column, {
                          align: "center",
                          label: "测试场景"
                        }, {
                          default: _withId((scope) => [
                            _createVNode("span", null, _toDisplayString(scope.row.name), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          align: "center",
                          label: "测试画质"
                        }, {
                          default: _withId((scope) => [
                            _createVNode("span", null, _toDisplayString(scope.row.picture), 1)
                          ]),
                          _: 1
                        }),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.nativeVersionList, (item) => {
                          return (_openBlock(), _createBlock(_component_el_table_column, {
                            key: item,
                            align: "center",
                            label: item.head + ':v.' + item.value + ''
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.target, (v) => {
                                return (_openBlock(), _createBlock(_component_el_table_column, {
                                  key: v,
                                  align: "center",
                                  width: v == 'unreleaseMallocSize' ? '160' : 120
                                }, {
                                  header: _withId(() => [
                                    _createVNode("div", null, _toDisplayString(v == "totalMallocSize"
                            ? "TotalNative"
                            : "UnreleasedNative"), 1),
                                    _hoisted_35
                                  ]),
                                  default: _withId((scope) => [
                                    _createVNode("span", null, _toDisplayString(scope.row.data[item.label][v]), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["width"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["label"]))
                        }), 128)),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.changeList, (item, i) => {
                          return (_openBlock(), _createBlock(_component_el_table_column, {
                            key: i,
                            align: "center"
                          }, {
                            header: _withId(() => [
                              _createVNode("div", null, _toDisplayString(item.head + ""), 1),
                              _createVNode("div", null, _toDisplayString((item.head == "基线变化值" ? "基线版本" : "上一版本") +
                        ":v." +
                        item.value), 1)
                            ]),
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.target, (v, index) => {
                                return (_openBlock(), _createBlock(_component_el_table_column, {
                                  key: index,
                                  align: "center",
                                  width: 
                      item.i[index] == 'unreleaseMallocSize' ? '160' : 120
                    
                                }, {
                                  header: _withId(() => [
                                    _createVNode("div", null, _toDisplayString(item.i[index] == "unreleaseMallocSize"
                            ? "UnreleasedNative"
                            : "TotalNative"), 1),
                                    _hoisted_36
                                  ]),
                                  default: _withId((scope) => [
                                    _createVNode("span", {
                                      style: 'color:' + scope.row.data[item.color[index]]
                                    }, _toDisplayString(_ctx.risk_color(scope.row.data[v])[0]), 5)
                                  ]),
                                  _: 2
                                }, 1032, ["width"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1024))
                        }), 128)),
                        _createVNode(_component_el_table_column, {
                          align: "center",
                          label: "风险"
                        }, {
                          default: _withId((scope) => [
                            _createVNode("span", {
                              style: 'color:' + _ctx.risk(scope.row.data.risk)
                            }, _toDisplayString(scope.row.data.risk), 5)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["span-method", "data"]), [
                      [_directive_loading, _ctx.report_loading]
                    ]),
                    (_ctx.perfReport_top?.length > 0)
                      ? (_openBlock(), _createBlock("div", _hoisted_37, [
                          _hoisted_38,
                          _withDirectives(_createVNode(_component_el_table, {
                            class: "custom-table_top",
                            border: "",
                            size: "mini",
                            "span-method": _ctx.mergeCells1,
                            "header-cell-style": {
                    background: '#5D99D5',
                    color: '#fff',
                  },
                            data: _ctx.perfReport_top
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_table_column, {
                                align: "center",
                                label: "测试画质"
                              }, {
                                default: _withId((scope) => [
                                  _createVNode("span", null, _toDisplayString(scope.row.level), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                align: "center",
                                label: "版本对比"
                              }, {
                                default: _withId((scope) => [
                                  _createVNode("span", null, _toDisplayString(scope.row.curVersion), 1),
                                  _hoisted_39,
                                  _createVNode("span", null, _toDisplayString(scope.row.lastVersion), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                align: "center",
                                width: "150",
                                label: "测试场景"
                              }, {
                                default: _withId((scope) => [
                                  _createVNode("span", null, _toDisplayString(scope.row.scene), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                width: "150",
                                label: "UnreleasedNativeMallocSize内存变化(MB)"
                              }, {
                                header: _withId(() => [
                                  _hoisted_40,
                                  _hoisted_41
                                ]),
                                default: _withId((scope) => [
                                  _createVNode("span", null, _toDisplayString(scope.row.diif_new), 1),
                                  _createVNode("span", {
                                    style: 'color:' + _ctx.risk_color(scope.row.memory_diff)[1]
                                  }, "(" + _toDisplayString(_ctx.risk_color(scope.row.memory_diff)[0]) + ")", 5)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                align: "center",
                                label: "火焰图"
                              }, {
                                default: _withId((scope) => [
                                  _createVNode("span", {
                                    class: "download-link",
                                    onClick: ($event: any) => (_ctx.downLoadNew(scope.row, 'func'))
                                  }, "下载", 8, ["onClick"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                "show-overflow-tooltip": true,
                                width: "450",
                                label: "Top增长函数"
                              }, {
                                default: _withId((scope) => [
                                  _createVNode("span", null, _toDisplayString(scope.row.funcName), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                width: "180",
                                align: "center",
                                label: "增长未释放"
                              }, {
                                header: _withId(() => [
                                  _hoisted_42,
                                  _hoisted_43
                                ]),
                                default: _withId((scope) => [
                                  _createVNode("span", null, _toDisplayString(scope.row.diff), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["span-method", "data"]), [
                            [_directive_loading, _ctx.report_loading]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.perfReport_so_top?.length > 0)
                      ? (_openBlock(), _createBlock("div", _hoisted_44, [
                          _hoisted_45,
                          _withDirectives(_createVNode(_component_el_table, {
                            class: "custom-table_top",
                            border: "",
                            size: "mini",
                            "span-method": _ctx.mergeCells_so,
                            "header-cell-style": {
                    background: '#5D99D5',
                    color: '#fff',
                  },
                            data: _ctx.perfReport_so_top
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_table_column, {
                                align: "center",
                                label: "测试画质"
                              }, {
                                default: _withId((scope) => [
                                  _createVNode("span", null, _toDisplayString(scope.row.level), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                align: "center",
                                label: "版本对比"
                              }, {
                                default: _withId((scope) => [
                                  _createVNode("span", null, _toDisplayString(scope.row.curVersion), 1),
                                  _hoisted_46,
                                  _createVNode("span", null, _toDisplayString(scope.row.lastVersion), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                align: "center",
                                width: "150",
                                label: "测试场景"
                              }, {
                                default: _withId((scope) => [
                                  _createVNode("span", null, _toDisplayString(scope.row.scene), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                width: "150",
                                label: "UnreleasedNativeMallocSize内存变化(MB)"
                              }, {
                                header: _withId(() => [
                                  _hoisted_47,
                                  _hoisted_48
                                ]),
                                default: _withId((scope) => [
                                  _createVNode("span", null, _toDisplayString(scope.row.diif_new), 1),
                                  _createVNode("span", {
                                    style: 'color:' + _ctx.risk_color(scope.row.memory_diff)[1]
                                  }, "(" + _toDisplayString(_ctx.risk_color(scope.row.memory_diff)[0]) + ")", 5)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                align: "center",
                                label: "火焰图"
                              }, {
                                default: _withId((scope) => [
                                  _createVNode("span", {
                                    class: "download-link",
                                    onClick: ($event: any) => (_ctx.downLoadNew(scope.row, 'so'))
                                  }, "下载", 8, ["onClick"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                "show-overflow-tooltip": true,
                                width: "450",
                                label: "Top增长so"
                              }, {
                                default: _withId((scope) => [
                                  _createVNode("span", null, _toDisplayString(scope.row.funcName), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                width: "180",
                                align: "center",
                                label: "增长未释放"
                              }, {
                                header: _withId(() => [
                                  _hoisted_49,
                                  _hoisted_50
                                ]),
                                default: _withId((scope) => [
                                  _createVNode("span", null, _toDisplayString(scope.row.diff), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["span-method", "data"]), [
                            [_directive_loading, _ctx.report_loading]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_51, [
                    _hoisted_52,
                    _hoisted_53,
                    _createVNode("div", null, [
                      _createVNode(_component_el_form, {
                        inline: true,
                        style: {"margin-top":"11px"},
                        size: "mini"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "选择画质" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                onChange: _ctx.trendChange,
                                modelValue: _ctx.level_trend,
                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.level_trend = $event)),
                                placeholder: "请选择"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.perfLeveOptions, (item, k) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: k,
                                      label: item.name,
                                      value: item.level
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["onChange", "modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "时间范围" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_date_picker, {
                                modelValue: _ctx.valueTime,
                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.valueTime = $event)),
                                type: "daterange",
                                "range-separator": "To",
                                "start-placeholder": "开始日期",
                                "end-placeholder": "结束日期",
                                onChange: _ctx.timeChange
                              }, null, 8, ["modelValue", "onChange"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_card, null, {
                        default: _withId(() => [
                          _hoisted_54
                        ]),
                        _: 1
                      })
                    ]),
                    (_ctx.funcSoTrend?.length > 0)
                      ? (_openBlock(), _createBlock("h6", _hoisted_55, [
                          _hoisted_56,
                          _hoisted_57
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.funcSoTrend?.length > 0)
                      ? (_openBlock(), _createBlock("div", _hoisted_58, [
                          _createVNode(_component_el_form, {
                            style: {"margin-top":"11px"},
                            inline: true,
                            size: "mini"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_form_item, { label: "选择画质" }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_select, {
                                    onChange: _ctx.funcChange_api_so,
                                    modelValue: _ctx.level_func_so,
                                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.level_func_so = $event)),
                                    placeholder: "请选择"
                                  }, {
                                    default: _withId(() => [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.perfLeveOptions, (item, k) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: k,
                                          label: item.name,
                                          value: item.level
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["onChange", "modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, { label: "选择场景" }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_select, {
                                    filterable: "",
                                    onChange: _ctx.funcChange_api_so,
                                    modelValue: _ctx.scene_func_id_so,
                                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.scene_func_id_so = $event)),
                                    placeholder: "请选择"
                                  }, {
                                    default: _withId(() => [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.perfSceneOptions, (item, k) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: k,
                                          label: item.name,
                                          value: item.scene_id
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["onChange", "modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, { label: "搜索so" }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_select, {
                                    onChange: _ctx.funcChange_so,
                                    modelValue: _ctx.index_func_so,
                                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.index_func_so = $event)),
                                    filterable: "",
                                    multiple: "",
                                    class: "input_none",
                                    "collapse-tags": "",
                                    placeholder: "请选择"
                                  }, {
                                    default: _withId(() => [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.funcSoTrend, (item, k) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: k,
                                          label: item,
                                          value: item
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["onChange", "modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _withDirectives(_createVNode(_component_el_card, null, {
                            default: _withId(() => [
                              _hoisted_59
                            ]),
                            _: 1
                          }, 512), [
                            [_directive_loading, _ctx.soLoading]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_60,
                    _createVNode("div", null, [
                      _createVNode(_component_el_form, {
                        style: {"margin-top":"11px"},
                        inline: true,
                        size: "mini"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "选择画质" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                onChange: _ctx.funcChange_api,
                                modelValue: _ctx.level_func,
                                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.level_func = $event)),
                                placeholder: "请选择"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.perfLeveOptions, (item, k) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: k,
                                      label: item.name,
                                      value: item.level
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["onChange", "modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "选择场景" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                filterable: "",
                                onChange: _ctx.funcChange_api,
                                modelValue: _ctx.scene_func_id,
                                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.scene_func_id = $event)),
                                placeholder: "请选择"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.perfSceneOptions, (item, k) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: k,
                                      label: item.name,
                                      value: item.scene_id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["onChange", "modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "搜索函数" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                onChange: _ctx.funcChange,
                                modelValue: _ctx.index_func,
                                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.index_func = $event)),
                                filterable: "",
                                multiple: "",
                                class: "input_none",
                                "collapse-tags": "",
                                placeholder: "请选择"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.funcTrend.func_list, (item, k) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: k,
                                      label: item,
                                      value: item
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["onChange", "modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _withDirectives(_createVNode(_component_el_card, null, {
                        default: _withId(() => [
                          _hoisted_61
                        ]),
                        _: 1
                      }, 512), [
                        [_directive_loading, _ctx.funcLoading]
                      ])
                    ])
                  ]),
                  (_ctx.localProject != 13)
                    ? (_openBlock(), _createBlock("div", _hoisted_62, [
                        _hoisted_63,
                        _createVNode(_component_el_form, {
                          inline: true,
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "选择画质" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  onChange: _ctx.importantChange,
                                  modelValue: _ctx.level,
                                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.level = $event)),
                                  placeholder: "请选择"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.perfLeveOptions, (item, k) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: k,
                                        label: item.name,
                                        value: item.level
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["onChange", "modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "选择场景" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  filterable: "",
                                  onChange: _ctx.importantChange,
                                  modelValue: _ctx.scene_id,
                                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.scene_id = $event)),
                                  placeholder: "请选择"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.perfSceneOptions, (item, k) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: k,
                                        label: item.name,
                                        value: item.scene_id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["onChange", "modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _hoisted_64,
                        (_ctx.localProject == 7)
                          ? (_openBlock(), _createBlock("div", _hoisted_65, [
                              _hoisted_66,
                              _withDirectives(_createVNode(_component_el_card, null, {
                                default: _withId(() => [
                                  _hoisted_67
                                ]),
                                _: 1
                              }, 512), [
                                [_directive_loading, _ctx.moudle_trend_loading]
                              ]),
                              _hoisted_68,
                              _withDirectives(_createVNode(_component_el_table, {
                                size: "mini",
                                "header-cell-style": {
                    background: '#5D99D5',
                    color: '#fff',
                  },
                                onSortChange: _ctx.sort_change_history,
                                data: 
                    _ctx.module_list?.slice(
                      (_ctx.page_module - 1) * _ctx.size_module,
                      _ctx.page_module * _ctx.size_module
                    )
                  
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_table_column, { label: "模块" }, {
                                    default: _withId((scope) => [
                                      _createVNode("span", null, _toDisplayString(scope.row.name), 1)
                                    ]),
                                    _: 1
                                  }),
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.module_list_data?.date_list, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_table_column, {
                                      key: item,
                                      label: item,
                                      prop: item
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_table_column, {
                                          prop: item,
                                          sortable: "custom",
                                          label: "数值(MB)"
                                        }, {
                                          default: _withId((scope) => [
                                            _createVNode("span", null, _toDisplayString(scope.row.data[item][scope.row.name].unreleasedSize
                            ? (
                                scope.row.data[item][scope.row.name]
                                  .unreleasedSize /
                                1024 /
                                1024
                              ).toFixed(2)
                            : "-"), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["prop"]),
                                        _createVNode(_component_el_table_column, { label: "数值(次数)" }, {
                                          default: _withId((scope) => [
                                            _createVNode("span", null, _toDisplayString(scope.row.data[item][scope.row.name].unreleasedNumber), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1032, ["label", "prop"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["onSortChange", "data"]), [
                                [_directive_loading, _ctx.moudle_list_loading]
                              ]),
                              _createVNode(_component_el_form, {
                                style: {"display":"flex","align-items":"center","margin-top":"19px"},
                                inline: true,
                                size: "mini"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_form_item, {
                                    style: {"margin-bottom":"0"},
                                    label: "每页"
                                  }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.size_module,
                                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.size_module = $event)),
                                        style: {"width":"55px","height":"28px"}
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_form_item, {
                                    style: {"margin-bottom":"0"},
                                    label: "条记录"
                                  }),
                                  _createVNode(_component_el_form_item, { style: {"margin-bottom":"0"} }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_pagination, {
                                        style: {"text-align":"right"},
                                        currentPage: _ctx.page_module,
                                        "onUpdate:currentPage": _cache[30] || (_cache[30] = ($event: any) => (_ctx.page_module = $event)),
                                        "page-size": _ctx.size_module,
                                        total: _ctx.module_list?.length,
                                        layout: "total, prev, pager, next,jumper"
                                      }, null, 8, ["currentPage", "page-size", "total"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true),
                        _hoisted_69,
                        _withDirectives(_createVNode(_component_el_table, {
                          border: "",
                          "span-method": _ctx.mergeCells,
                          size: "mini",
                          "header-cell-style": {
                  background: '#5D99D5',
                  color: '#fff',
                },
                          onSortChange: _ctx.sort_change_detail,
                          data: 
                  _ctx.nativeModuleData?.slice(
                    (_ctx.page_native - 1) * _ctx.size_native,
                    _ctx.page_native * _ctx.size_native
                  )
                
                        }, {
                          default: _withId(() => [
                            (_ctx.localProject != 7)
                              ? (_openBlock(), _createBlock(_component_el_table_column, {
                                  key: 0,
                                  label: "父模块"
                                }, {
                                  default: _withId((scope) => [
                                    _createVNode("span", null, _toDisplayString(scope.row.parent), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_el_table_column, {
                              "show-overflow-tooltip": true,
                              label: _ctx.localProject == 7 ? '模块' : '子模块'
                            }, {
                              default: _withId((scope) => [
                                _createVNode("span", null, _toDisplayString(scope.row.sub), 1)
                              ]),
                              _: 1
                            }, 8, ["label"]),
                            _createVNode(_component_el_table_column, {
                              "show-overflow-tooltip": true,
                              label: "函数"
                            }, {
                              default: _withId((scope) => [
                                _createVNode("span", null, _toDisplayString(scope.row.func), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              align: "center",
                              label: "UnreleasedSize"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_table_column, {
                                  sortable: "size",
                                  prop: "size",
                                  align: "center",
                                  label: '数值(MB)'
                                }, {
                                  default: _withId((scope) => [
                                    _createVNode("span", null, _toDisplayString(scope.row.data.size), 1)
                                  ]),
                                  _: 1
                                }, 8, ["label"]),
                                _createVNode(_component_el_table_column, {
                                  sortable: "diff_size_old",
                                  prop: "diff_size_old",
                                  align: "center",
                                  label: "前后差异(MB)"
                                }, {
                                  default: _withId((scope) => [
                                    _createVNode("span", {
                                      style: 
                          'color:' + _ctx.text(scope.row.data.diff_size_old)[1]
                        
                                    }, _toDisplayString(_ctx.text(scope.row.data.diff_size_old)[0]), 5)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  sortable: "diff_size_base",
                                  prop: "diff_size_base",
                                  align: "center",
                                  label: "基线差异(MB)"
                                }, {
                                  default: _withId((scope) => [
                                    _createVNode("span", {
                                      style: 
                          'color:' + _ctx.text(scope.row.data.diff_size_base)[1]
                        
                                    }, _toDisplayString(_ctx.text(scope.row.data.diff_size_base)[0]), 5)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              align: "center",
                              label: "UnreleasedNumber"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_table_column, {
                                  align: "center",
                                  sortable: "num",
                                  prop: "num",
                                  label: '数值(次数)'
                                }, {
                                  default: _withId((scope) => [
                                    _createVNode("span", null, _toDisplayString(scope.row.data.num), 1)
                                  ]),
                                  _: 1
                                }, 8, ["label"]),
                                _createVNode(_component_el_table_column, {
                                  sortable: "diff_num_old",
                                  prop: "diff_num_old",
                                  align: "center",
                                  label: "前后差异(次数)"
                                }, {
                                  default: _withId((scope) => [
                                    _createVNode("span", {
                                      style: 'color:' + _ctx.text(scope.row.data.diff_num_old)[1]
                                    }, _toDisplayString(_ctx.text(scope.row.data.diff_num_old)[0]), 5)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  sortable: "diff_num_base",
                                  prop: "diff_num_base",
                                  align: "center",
                                  label: "基线差异(次数)"
                                }, {
                                  default: _withId((scope) => [
                                    _createVNode("span", {
                                      style: 
                          'color:' + _ctx.text(scope.row.data.diff_num_base)[1]
                        
                                    }, _toDisplayString(_ctx.text(scope.row.data.diff_num_base)[0]), 5)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["span-method", "onSortChange", "data"]), [
                          [_directive_loading, _ctx.moudle_loading]
                        ]),
                        _createVNode(_component_el_form, {
                          style: {"display":"flex","align-items":"center","margin-top":"19px"},
                          inline: true,
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, {
                              style: {"margin-bottom":"0"},
                              label: "每页"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.size_native,
                                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.size_native = $event)),
                                  style: {"width":"55px","height":"28px"}
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              style: {"margin-bottom":"0"},
                              label: "条记录"
                            }),
                            _createVNode(_component_el_form_item, { style: {"margin-bottom":"0"} }, {
                              default: _withId(() => [
                                _createVNode(_component_el_pagination, {
                                  style: {"text-align":"right"},
                                  currentPage: _ctx.page_native,
                                  "onUpdate:currentPage": _cache[32] || (_cache[32] = ($event: any) => (_ctx.page_native = $event)),
                                  "page-size": _ctx.size_native,
                                  total: _ctx.nativeModuleData?.length,
                                  layout: "total, prev, pager, next,jumper"
                                }, null, 8, ["currentPage", "page-size", "total"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.localProject != 7)
                    ? (_openBlock(), _createBlock("div", _hoisted_70, [
                        _hoisted_71,
                        _createVNode("div", _hoisted_72, [
                          _createVNode(_component_el_form, {
                            class: "spacForm",
                            size: "mini",
                            inline: true
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_form_item, { label: "选择画质" }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_select, {
                                    onChange: _ctx.nativeAllChange,
                                    modelValue: _ctx.level_all,
                                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (_ctx.level_all = $event)),
                                    placeholder: "请选择"
                                  }, {
                                    default: _withId(() => [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.perfLeveOptions, (item, k) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: k,
                                          label: item.name,
                                          value: item.level
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["onChange", "modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, { label: "选择场景" }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_select, {
                                    onChange: _ctx.nativeAllChange,
                                    modelValue: _ctx.scene_natvie_id,
                                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.scene_natvie_id = $event)),
                                    placeholder: "请选择"
                                  }, {
                                    default: _withId(() => [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.perfSceneOptions, (item, k) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: k,
                                          label: item.name,
                                          value: item.scene_id
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["onChange", "modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, { label: "对比数据版本" }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_select, {
                                    onChange: _ctx.nativeAllChange,
                                    key: _ctx.componentKey,
                                    modelValue: _ctx.old_date_name,
                                    "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (_ctx.old_date_name = $event)),
                                    placeholder: "请选择"
                                  }, {
                                    default: _withId(() => [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.perfDateOptions, (item, k) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: k,
                                          label: item.name,
                                          value: item.name
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["onChange", "modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode("div", null, [
                            _createVNode(_component_el_button, {
                              size: "mini",
                              type: "primary",
                              onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.downloadCsv()))
                            }, {
                              default: _withId(() => [
                                _hoisted_73
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createVNode(_component_el_form, {
                          size: "mini",
                          inline: true
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "搜索" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.serch_input,
                                  "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (_ctx.serch_input = $event)),
                                  onChange: _cache[38] || (_cache[38] = ($event: any) => (_ctx.onSearch(true))),
                                  "prefix-icon": "el-icon-search",
                                  size: "mini"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "Top" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  onChange: _cache[39] || (_cache[39] = ($event: any) => (_ctx.onSearch(true))),
                                  modelValue: _ctx.top,
                                  "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (_ctx.top = $event)),
                                  placeholder: "请选择"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sizeOptions, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item,
                                        label: item,
                                        value: item
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode("div", _hoisted_74, [
                          _withDirectives(_createVNode(_component_el_table, {
                            id: "detailTable",
                            border: "",
                            size: "mini",
                            "header-cell-style": {
                    background: '#5D99D5',
                    color: '#fff',
                  },
                            key: _ctx.newCount,
                            onSortChange: _ctx.sort_change,
                            data: _ctx.nativeTableAll
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_table_column, {
                                align: "left",
                                sortable: "custom",
                                "show-overflow-tooltip": true,
                                label: "functionName",
                                width: "200",
                                prop: "functionName"
                              }),
                              _createVNode(_component_el_table_column, {
                                width: "150",
                                align: "left",
                                sortable: "custom",
                                "show-overflow-tooltip": true,
                                label: "sourceFileName",
                                prop: "sourceFileName"
                              }),
                              _createVNode(_component_el_table_column, {
                                width: "120",
                                align: "left",
                                sortable: "custom",
                                "show-overflow-tooltip": true,
                                label: "soName",
                                prop: "soName"
                              }),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.nativeAllHead, (item) => {
                                return (_openBlock(), _createBlock(_component_el_table_column, {
                                  align: "center",
                                  label: 
                      item.label +
                      (item.new.indexOf('Number') != -1 ? '' : '(MB)')
                    ,
                                  key: item
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_table_column, {
                                      align: "center",
                                      sortable: "custom",
                                      prop: item.new,
                                      label: "数值"
                                    }, {
                                      default: _withId((scope) => [
                                        _createTextVNode(_toDisplayString(scope.row[item.new]), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["prop"]),
                                    _createVNode(_component_el_table_column, {
                                      align: "center",
                                      sortable: "custom",
                                      prop: item.old,
                                      label: "差异"
                                    }, {
                                      default: _withId((scope) => [
                                        _createTextVNode(_toDisplayString(_ctx.risk_color(scope.row[item.old])[0]), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["prop"])
                                  ]),
                                  _: 2
                                }, 1032, ["label"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["onSortChange", "data"]), [
                            [_directive_loading, _ctx.nativeTableAllLoading]
                          ])
                        ]),
                        _createVNode(_component_el_form, {
                          style: {"display":"flex","align-items":"center","margin-top":"19px"},
                          inline: true,
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, {
                              style: {"margin-bottom":"0"},
                              label: "每页"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.size,
                                  "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => (_ctx.size = $event)),
                                  style: {"width":"55px","height":"28px"},
                                  onChange: _cache[42] || (_cache[42] = ($event: any) => (_ctx.onSearch(false)))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              style: {"margin-bottom":"0"},
                              label: "条记录"
                            }),
                            _createVNode(_component_el_form_item, { style: {"margin-bottom":"0"} }, {
                              default: _withId(() => [
                                _createVNode(_component_el_pagination, {
                                  style: {"text-align":"right"},
                                  currentPage: _ctx.page,
                                  "onUpdate:currentPage": _cache[43] || (_cache[43] = ($event: any) => (_ctx.page = $event)),
                                  "page-size": _ctx.size,
                                  total: _ctx.nativeAllData?.length,
                                  layout: "total, prev, pager, next,jumper",
                                  onCurrentChange: _cache[44] || (_cache[44] = ($event: any) => (_ctx.onSearch(false)))
                                }, null, 8, ["currentPage", "page-size", "total"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.nativeAllSoData?.length > 0)
                    ? (_openBlock(), _createBlock("div", _hoisted_75, [
                        _hoisted_76,
                        _createVNode("div", _hoisted_77, [
                          _createVNode(_component_el_form, {
                            class: "spacForm",
                            size: "mini",
                            inline: true
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_form_item, { label: "选择画质" }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_select, {
                                    onChange: _ctx.nativeAllChangeSo,
                                    modelValue: _ctx.level_so,
                                    "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => (_ctx.level_so = $event)),
                                    placeholder: "请选择"
                                  }, {
                                    default: _withId(() => [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.perfLeveOptions, (item, k) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: k,
                                          label: item.name,
                                          value: item.level
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["onChange", "modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, { label: "选择场景" }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_select, {
                                    onChange: _ctx.nativeAllChangeSo,
                                    modelValue: _ctx.scene_so_id,
                                    "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => (_ctx.scene_so_id = $event)),
                                    placeholder: "请选择"
                                  }, {
                                    default: _withId(() => [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.perfSceneOptions, (item, k) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: k,
                                          label: item.name,
                                          value: item.scene_id
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["onChange", "modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, { label: "对比数据版本" }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_select, {
                                    onChange: _ctx.nativeAllChangeSo,
                                    key: _ctx.componentKey,
                                    modelValue: _ctx.old_date_so_name,
                                    "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => (_ctx.old_date_so_name = $event)),
                                    placeholder: "请选择"
                                  }, {
                                    default: _withId(() => [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.perfDateOptions, (item, k) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: k,
                                          label: item.name,
                                          value: item.name
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["onChange", "modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _createVNode(_component_el_form, {
                          size: "mini",
                          inline: true
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "搜索" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.serch_input_so,
                                  "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => (_ctx.serch_input_so = $event)),
                                  onChange: _cache[49] || (_cache[49] = ($event: any) => (_ctx.onSearchSo(true))),
                                  "prefix-icon": "el-icon-search",
                                  size: "mini"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "Top" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  onChange: _cache[50] || (_cache[50] = ($event: any) => (_ctx.onSearchSo(true))),
                                  modelValue: _ctx.top_so,
                                  "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => (_ctx.top_so = $event)),
                                  placeholder: "请选择"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sizeOptions, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item,
                                        label: item,
                                        value: item
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode("div", _hoisted_78, [
                          _withDirectives(_createVNode(_component_el_table, {
                            id: "detailTable",
                            border: "",
                            size: "mini",
                            "header-cell-style": {
                    background: '#5D99D5',
                    color: '#fff',
                  },
                            onSortChange: _ctx.sort_change_so,
                            data: _ctx.nativeTableSoAll
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_table_column, {
                                width: "300",
                                sortable: "custom",
                                "show-overflow-tooltip": true,
                                label: "soName",
                                prop: "soName"
                              }),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.nativeAllHead1, (item) => {
                                return (_openBlock(), _createBlock(_component_el_table_column, {
                                  align: "center",
                                  label: 
                      item.label +
                      (item.new.indexOf('Number') != -1 ? '' : '(MB)')
                    ,
                                  key: item
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_table_column, {
                                      align: "center",
                                      sortable: "custom",
                                      prop: item.new,
                                      label: "数值"
                                    }, {
                                      default: _withId((scope) => [
                                        _createTextVNode(_toDisplayString(scope.row[item.new]), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["prop"]),
                                    _createVNode(_component_el_table_column, {
                                      align: "center",
                                      sortable: "custom",
                                      prop: item.old,
                                      label: "差异"
                                    }, {
                                      default: _withId((scope) => [
                                        _createTextVNode(_toDisplayString(_ctx.risk_color(scope.row[item.old])[0]), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["prop"])
                                  ]),
                                  _: 2
                                }, 1032, ["label"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["onSortChange", "data"]), [
                            [_directive_loading, _ctx.nativeTableAllLoading]
                          ])
                        ]),
                        _createVNode(_component_el_form, {
                          style: {"display":"flex","align-items":"center","margin-top":"19px"},
                          inline: true,
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, {
                              style: {"margin-bottom":"0"},
                              label: "每页"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.size_so,
                                  "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => (_ctx.size_so = $event)),
                                  style: {"width":"55px","height":"28px"},
                                  onChange: _cache[53] || (_cache[53] = ($event: any) => (_ctx.onSearchSo(false)))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              style: {"margin-bottom":"0"},
                              label: "条记录"
                            }),
                            _createVNode(_component_el_form_item, { style: {"margin-bottom":"0"} }, {
                              default: _withId(() => [
                                _createVNode(_component_el_pagination, {
                                  style: {"text-align":"right"},
                                  currentPage: _ctx.page_so,
                                  "onUpdate:currentPage": _cache[54] || (_cache[54] = ($event: any) => (_ctx.page_so = $event)),
                                  "page-size": _ctx.size_so,
                                  total: _ctx.nativeAllSoData?.length,
                                  layout: "total, prev, pager, next,jumper",
                                  onCurrentChange: _cache[55] || (_cache[55] = ($event: any) => (_ctx.onSearchSo(false)))
                                }, null, 8, ["currentPage", "page-size", "total"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_79,
                  _createVNode(_component_el_form, {
                    class: "spacForm",
                    size: "mini",
                    inline: true
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form_item, { label: "选择画质" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            onChange: _ctx.flameAllChangeSo,
                            modelValue: _ctx.flame_so,
                            "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => (_ctx.flame_so = $event)),
                            placeholder: "请选择"
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.perfLeveOptions, (item, k) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: k,
                                  label: item.name,
                                  value: item.level
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["onChange", "modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "选择场景" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            onChange: _ctx.flameAllChangeSo,
                            modelValue: _ctx.scene_flame_id,
                            "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => (_ctx.scene_flame_id = $event)),
                            placeholder: "请选择"
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.perfSceneOptions, (item, k) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: k,
                                  label: item.name,
                                  value: item.scene_id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["onChange", "modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form, {
                    class: "spacForm",
                    size: "mini",
                    inline: true
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form_item, { label: "size" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_input, {
                            placeholder: "单位KB",
                            modelValue: _ctx.flame_size_input,
                            "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => (_ctx.flame_size_input = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "so" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.flame_so_input,
                            "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => (_ctx.flame_so_input = $event)),
                            multiple: "",
                            filterable: "",
                            "collapse-tags": "",
                            "collapse-tags-tooltip": "",
                            placeholder: "请选择"
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.funcSoTrend, (item, k) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: k,
                                  label: item,
                                  value: item
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "function" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.flame_function_input,
                            "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => (_ctx.flame_function_input = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, null, {
                        default: _withId(() => [
                          _createVNode(_component_el_button, {
                            onClick: _ctx.flame_btn,
                            type: "primary"
                          }, {
                            default: _withId(() => [
                              _hoisted_80
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, null, {
                        default: _withId(() => [
                          _createVNode(_component_el_button, {
                            onClick: _ctx.check_view_memory,
                            type: "primary"
                          }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(_ctx.changeViewMemory ? "相对视图" : "原始视图"), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, null, {
                        default: _withId(() => [
                          _createVNode(_component_el_button, {
                            onClick: _cache[61] || (_cache[61] = ($event: any) => (_ctx.screen('memory'))),
                            type: "primary"
                          }, {
                            default: _withId(() => [
                              _hoisted_81
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_ctx.flameShow)
                    ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_82, [
                        _hoisted_83
                      ], 512)), [
                        [_directive_loading, _ctx.flameLoading]
                      ])
                    : (_openBlock(), _createBlock("div", _hoisted_84, [
                        _createVNode(_component_el_empty, { description: "无堆栈数据" })
                      ])),
                  (_ctx.localProject == 7)
                    ? (_openBlock(), _createBlock("div", _hoisted_85, [
                        _hoisted_86,
                        _createVNode(_component_el_form, {
                          class: "spacForm",
                          size: "mini",
                          inline: true
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "选择画质" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.level_stack,
                                  "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => (_ctx.level_stack = $event)),
                                  placeholder: "请选择"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.perfLeveOptions, (item, k) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: k,
                                        label: item.name,
                                        value: item.level
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "选择场景" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.scene_stack_id,
                                  "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => (_ctx.scene_stack_id = $event)),
                                  placeholder: "请选择"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.perfSceneOptions, (item, k) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: k,
                                        label: item.name,
                                        value: item.scene_id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "对比数据版本" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.old_stack_name,
                                  "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => (_ctx.old_stack_name = $event)),
                                  placeholder: "请选择"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.perfDateOptions, (item, k) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: k,
                                        label: item.name,
                                        value: item.name
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form, {
                          class: "spacForm",
                          size: "mini",
                          inline: true
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "size" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  placeholder: "单位KB",
                                  modelValue: _ctx.flame_size_stack_input,
                                  "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => (_ctx.flame_size_stack_input = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "so" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.flame_stack_so_input,
                                  "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => (_ctx.flame_stack_so_input = $event)),
                                  multiple: "",
                                  filterable: "",
                                  "collapse-tags": "",
                                  "collapse-tags-tooltip": "",
                                  placeholder: "请选择"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.funcSoTrend, (item, k) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: k,
                                        label: item,
                                        value: item
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "function" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.flame_stack_function_input,
                                  "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => (_ctx.flame_stack_function_input = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, null, {
                              default: _withId(() => [
                                _createVNode(_component_el_button, {
                                  onClick: _ctx.flame_btn_stack,
                                  type: "primary"
                                }, {
                                  default: _withId(() => [
                                    _hoisted_87
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, null, {
                              default: _withId(() => [
                                _createVNode(_component_el_button, {
                                  onClick: _cache[68] || (_cache[68] = ($event: any) => (_ctx.screen('merge'))),
                                  type: "primary"
                                }, {
                                  default: _withId(() => [
                                    _hoisted_88
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode("div", null, [
                          false
                            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                _createVNode("div", _hoisted_89, [
                                  _createVNode("p", _hoisted_90, [
                                    _hoisted_91,
                                    _createVNode("span", _hoisted_92, _toDisplayString(_ctx.perfettoStack_v2?.increase?.count), 1),
                                    _hoisted_93
                                  ]),
                                  _createVNode("p", _hoisted_94, [
                                    _hoisted_95,
                                    _createVNode("span", _hoisted_96, _toDisplayString(_ctx.perfettoStack_v2?.tree?.count), 1),
                                    _hoisted_97
                                  ]),
                                  _createVNode("p", _hoisted_98, [
                                    _hoisted_99,
                                    _createVNode("span", _hoisted_100, _toDisplayString(_ctx.perfettoStack_v2?.decrease?.count), 1),
                                    _hoisted_101
                                  ])
                                ]),
                                (_ctx.merge_show)
                                  ? (_openBlock(), _createBlock("div", _hoisted_102))
                                  : (_openBlock(), _createBlock("div", _hoisted_103, [
                                      _createVNode(_component_el_empty, { description: "无堆栈数据" })
                                    ])),
                                _createVNode(_component_el_form, { "label-width": "auto" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_form_item, { label: "堆栈类型" }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_select, {
                                          modelValue: _ctx.stackType,
                                          "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => (_ctx.stackType = $event)),
                                          size: "mini",
                                          placeholder: ""
                                        }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_option, {
                                              label: "相同堆栈",
                                              value: "tree"
                                            }),
                                            _createVNode(_component_el_option, {
                                              label: "新增堆栈",
                                              value: "increase"
                                            }),
                                            _createVNode(_component_el_option, {
                                              label: "减少堆栈",
                                              value: "decrease"
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ], 64))
                            : _createCommentVNode("", true),
                          _createVNode(_component_el_table, {
                            data: _ctx.stackTableData,
                            "row-key": "rowKey",
                            key: _ctx.stackTableKey,
                            lazy: "",
                            border: "",
                            load: _ctx.loadStackChildren
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_table_column, {
                                prop: "functionName",
                                label: "functionName",
                                width: "",
                                resizable: ""
                              }),
                              _createVNode(_component_el_table_column, {
                                prop: "soName",
                                label: "soName",
                                width: "200",
                                resizable: ""
                              }),
                              _createVNode(_component_el_table_column, {
                                prop: "curVal",
                                label: "当前值",
                                width: "100",
                                resizable: ""
                              }),
                              _createVNode(_component_el_table_column, {
                                prop: "selfText",
                                label: "self变化值",
                                width: "100",
                                resizable: ""
                              })
                            ]),
                            _: 1
                          }, 8, ["data", "load"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.localProject == 7)
                    ? (_openBlock(), _createBlock("div", _hoisted_104, [
                        _hoisted_105,
                        _createVNode("div", _hoisted_106, [
                          _createVNode(_component_el_form, {
                            class: "spacForm",
                            size: "mini",
                            inline: true
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_form_item, { label: "选择画质" }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_select, {
                                    onChange: _ctx.nativeAllChange,
                                    modelValue: _ctx.level_all,
                                    "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => (_ctx.level_all = $event)),
                                    placeholder: "请选择"
                                  }, {
                                    default: _withId(() => [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.perfLeveOptions, (item, k) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: k,
                                          label: item.name,
                                          value: item.level
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["onChange", "modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, { label: "选择场景" }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_select, {
                                    onChange: _ctx.nativeAllChange,
                                    modelValue: _ctx.scene_natvie_id,
                                    "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => (_ctx.scene_natvie_id = $event)),
                                    placeholder: "请选择"
                                  }, {
                                    default: _withId(() => [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.perfSceneOptions, (item, k) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: k,
                                          label: item.name,
                                          value: item.scene_id
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["onChange", "modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, { label: "对比数据版本" }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_select, {
                                    onChange: _ctx.nativeAllChange,
                                    key: _ctx.componentKey,
                                    modelValue: _ctx.old_date_name,
                                    "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => (_ctx.old_date_name = $event)),
                                    placeholder: "请选择"
                                  }, {
                                    default: _withId(() => [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.perfDateOptions, (item, k) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: k,
                                          label: item.name,
                                          value: item.name
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["onChange", "modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode("div", null, [
                            _createVNode(_component_el_button, {
                              size: "mini",
                              type: "primary",
                              onClick: _cache[73] || (_cache[73] = ($event: any) => (_ctx.downloadCsv()))
                            }, {
                              default: _withId(() => [
                                _hoisted_107
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createVNode(_component_el_form, {
                          size: "mini",
                          inline: true
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "搜索" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.serch_input,
                                  "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => (_ctx.serch_input = $event)),
                                  onChange: _cache[75] || (_cache[75] = ($event: any) => (_ctx.onSearch(true))),
                                  "prefix-icon": "el-icon-search",
                                  size: "mini"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "Top" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  onChange: _cache[76] || (_cache[76] = ($event: any) => (_ctx.onSearch(true))),
                                  modelValue: _ctx.top,
                                  "onUpdate:modelValue": _cache[77] || (_cache[77] = ($event: any) => (_ctx.top = $event)),
                                  placeholder: "请选择"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sizeOptions, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item,
                                        label: item,
                                        value: item
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode("div", _hoisted_108, [
                          _withDirectives(_createVNode(_component_el_table, {
                            id: "detailTable",
                            border: "",
                            size: "mini",
                            "header-cell-style": {
                    background: '#5D99D5',
                    color: '#fff',
                  },
                            key: _ctx.newCount,
                            onSortChange: _ctx.sort_change,
                            data: _ctx.nativeTableAll
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_table_column, {
                                align: "left",
                                sortable: "custom",
                                "show-overflow-tooltip": true,
                                label: "functionName",
                                width: "200",
                                prop: "functionName"
                              }),
                              _createVNode(_component_el_table_column, {
                                width: "150",
                                align: "left",
                                sortable: "custom",
                                "show-overflow-tooltip": true,
                                label: "sourceFileName",
                                prop: "sourceFileName"
                              }),
                              _createVNode(_component_el_table_column, {
                                width: "120",
                                align: "left",
                                sortable: "custom",
                                "show-overflow-tooltip": true,
                                label: "soName",
                                prop: "soName"
                              }),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.nativeAllHead, (item) => {
                                return (_openBlock(), _createBlock(_component_el_table_column, {
                                  align: "center",
                                  label: 
                      item.label +
                      (item.new.indexOf('Number') != -1 ? '' : '(MB)')
                    ,
                                  key: item
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_table_column, {
                                      align: "center",
                                      sortable: "custom",
                                      prop: item.new,
                                      label: "数值"
                                    }, {
                                      default: _withId((scope) => [
                                        _createTextVNode(_toDisplayString(scope.row[item.new]), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["prop"]),
                                    _createVNode(_component_el_table_column, {
                                      align: "center",
                                      sortable: "custom",
                                      prop: item.old,
                                      label: "差异"
                                    }, {
                                      default: _withId((scope) => [
                                        _createTextVNode(_toDisplayString(_ctx.risk_color(scope.row[item.old])[0]), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["prop"])
                                  ]),
                                  _: 2
                                }, 1032, ["label"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["onSortChange", "data"]), [
                            [_directive_loading, _ctx.nativeTableAllLoading]
                          ])
                        ]),
                        _createVNode(_component_el_form, {
                          style: {"display":"flex","align-items":"center","margin-top":"19px"},
                          inline: true,
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, {
                              style: {"margin-bottom":"0"},
                              label: "每页"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.size,
                                  "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => (_ctx.size = $event)),
                                  style: {"width":"55px","height":"28px"},
                                  onChange: _cache[79] || (_cache[79] = ($event: any) => (_ctx.onSearch(false)))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              style: {"margin-bottom":"0"},
                              label: "条记录"
                            }),
                            _createVNode(_component_el_form_item, { style: {"margin-bottom":"0"} }, {
                              default: _withId(() => [
                                _createVNode(_component_el_pagination, {
                                  style: {"text-align":"right"},
                                  currentPage: _ctx.page,
                                  "onUpdate:currentPage": _cache[80] || (_cache[80] = ($event: any) => (_ctx.page = $event)),
                                  "page-size": _ctx.size,
                                  total: _ctx.nativeAllData?.length,
                                  layout: "total, prev, pager, next,jumper",
                                  onCurrentChange: _cache[81] || (_cache[81] = ($event: any) => (_ctx.onSearch(false)))
                                }, null, 8, ["currentPage", "page-size", "total"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_109, [
                    _hoisted_110,
                    _withDirectives(_createVNode(_component_el_table, {
                      border: "",
                      size: "mini",
                      "header-cell-style": {
                  background: '#5D99D5',
                  color: '#fff',
                },
                      data: _ctx.perfReport_file_list
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_table_column, {
                          align: "center",
                          label: "测试画质",
                          prop: "测试画质"
                        }),
                        _createVNode(_component_el_table_column, {
                          align: "center",
                          label: "测试场景",
                          prop: "测试场景"
                        }),
                        _createVNode(_component_el_table_column, {
                          align: "center",
                          label: "TotalNative内存火焰图"
                        }, {
                          default: _withId((scope) => [
                            _createVNode("a", {
                              style: {"color":"#61c3e4","text-decoration":"underline","cursor":"pointer"},
                              onClick: ($event: any) => (
                        _ctx.btnAll(scope.row['测试场景'], scope.row['测试画质'])
                      )
                            }, "点击查看 ", 8, ["onClick"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          align: "center",
                          label: "UnreleasedNative内存火焰图"
                        }, {
                          default: _withId((scope) => [
                            _createVNode("a", {
                              style: {"color":"#61c3e4","text-decoration":"underline","cursor":"pointer"},
                              onClick: ($event: any) => (_ctx.btn(scope.row['测试场景'], scope.row['测试画质']))
                            }, "点击查看火焰图 ", 8, ["onClick"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          align: "center",
                          label: "源数据下载"
                        }, {
                          default: _withId((scope) => [
                            _createVNode("a", {
                              download: "",
                              href: scope.row['源数据下载链接']
                            }, "数据下载", 8, ["href"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["data"]), [
                      [_directive_loading, _ctx.report_loading]
                    ])
                  ]),
                  (_ctx.localProject != 13)
                    ? (_openBlock(), _createBlock("div", _hoisted_111, [
                        _hoisted_112,
                        _createVNode(_component_el_table, {
                          border: "",
                          size: "mini",
                          "header-cell-style": {
                  background: '#5D99D5',
                  color: '#fff',
                },
                          data: _ctx.perfReport_overview
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_table_column, { label: "测试场景" }, {
                              default: _withId((scope) => [
                                _createVNode("span", null, _toDisplayString(scope.row.scene), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, { label: "测试场景说明" }, {
                              default: _withId((scope) => [
                                (!_ctx.edit_show)
                                  ? (_openBlock(), _createBlock("p", {
                                      key: 0,
                                      innerHTML: scope.row.text
                                    }, null, 8, ["innerHTML"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["data"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_113
              ]),
              (_ctx.backShow)
                ? (_openBlock(), _createBlock("div", _hoisted_114))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})